import { render, staticRenderFns } from "./indexf.vue?vue&type=template&id=6366b4ef&scoped=true"
import script from "./indexf.vue?vue&type=script&lang=js"
export * from "./indexf.vue?vue&type=script&lang=js"
import style0 from "./indexf.vue?vue&type=style&index=0&id=6366b4ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366b4ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6366b4ef')) {
      api.createRecord('6366b4ef', component.options)
    } else {
      api.reload('6366b4ef', component.options)
    }
    module.hot.accept("./indexf.vue?vue&type=template&id=6366b4ef&scoped=true", function () {
      api.rerender('6366b4ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/areamenu/indexf.vue"
export default component.exports